module.exports = __webpack_public_path__ + "static/media/slider06.84cde81b.jpg";